module.exports = __webpack_public_path__ + "img/kkb_hazebase.6871d69b.jpg";